import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import MaterialTable from "material-table";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";

import { TimePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Box, createTheme, Tab, TextField } from "@material-ui/core";

import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";
import isEqual from "date-fns/isEqual";

import { timeConvertUtility } from "../../utilities/utility";

// import { initializeApp, getApps, getApp } from "firebase/app";
import { db, getCheckSession, getUserName, logout } from "../../apis/auth";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  addDoc,
  updateDoc,
  increment,
  setDoc,
} from "firebase/firestore";
import "../../styles/settings.scss";
import { getDimSchedule, updateDimSchedule } from "../../query/dim-schedule.query";

import { DimSchedule } from "./dim-schedule.screen"
import { createDimScheduleHistory } from "../../query/dim-schedule-history.query";
import { NotificationManager } from "react-notifications";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

const Settings = () => {
  const history = useHistory();
  const classes = useStyles();

  const [scheduledTime, setScheduledTime] = useState("");
  const [dimSchedule, setDimSchedule] = useState({});
  const [scheduleHistoryData, setScheduleHistoryData] = useState([]);
  const [isOpenDialog, setIsOpenDialog] = useState(false);
  const [selectedStartTimeDate, setSelectedStartTimeDate] = useState(
    new Date()
  );
  const [selectedEndTimeDate, setSelectedEndTimeDate] = useState(new Date());
  const [scheduleDocId, setScheduleDocId] = useState(null);

  const [selectedTab, setSelectedTab] = React.useState('1');

  const [dimScheduleDialog, setDimScheduleDialog] = useState({ view: '', start: new Date(), end: new Date() });
  const [onUpdateDimSchedule, setOnUpdateDimSchedule] = useState(false);
  const onChangeTabView = (event, newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(async () => {
    console.log(`Tab Changed ${selectedTab}`);
    if (selectedTab == 2) {
      // Dim schedule
      getDimSchedule().then((response) => {
        setDimSchedule(response);
        console.log(response);
      }).catch((error) => {
        console.log(error);
      });
    }
  }, [selectedTab]);

  useEffect(async () => {
    console.log("========== LiveMeterFeed : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }
    // await getCheckSession().then(() => {
    // }).catch((e) => {
    //   logout();
    //   return;
    // });
    getScheduleInfoAPICall();
    getScheduleHistoryAPICall();
  }, []);

  const handleClose = () => {
    setIsOpenDialog(false);
  };

  const handleEdit = () => {
    setIsOpenDialog(true);
  };

  const handleSave = async () => {
    const user = await getUserName().catch((error) => {
      console.error(`User name not found. error = ${error}`);
    });
    if (scheduleDocId && selectedStartTimeDate && selectedEndTimeDate) {
      let { version: currentVersion } = scheduledTime;
      const docRef = doc(db(), "schedules", scheduleDocId);
      updateDoc(docRef, {
        "on_time.hrs": selectedStartTimeDate.getHours(),
        "on_time.mins": selectedStartTimeDate.getMinutes(),
        "off_time.hrs": selectedEndTimeDate.getHours(),
        "off_time.mins": selectedEndTimeDate.getMinutes(),
        version: increment(1),
      })
        .then(() => {
          console.log("schedule document updated successfully");
          currentVersion += 1;
          let newDocumentObj = {
            name: "default",
            on_time: {
              hrs: selectedStartTimeDate.getHours(),
              mins: selectedStartTimeDate.getMinutes(),
            },
            off_time: {
              hrs: selectedEndTimeDate.getHours(),
              mins: selectedEndTimeDate.getMinutes(),
            },
            user,
            ch_dt: new Date(),
            version: currentVersion,
          };
          addDoc(collection(db(), "schedule_history"), {
            ...newDocumentObj,
          })
            .then((res) => {
              console.log("schedule history document added : ", res);
              setScheduledTime((prevState) => ({
                ...prevState,
                on_time: {
                  hrs: selectedStartTimeDate.getHours(),
                  mins: selectedStartTimeDate.getMinutes(),
                },
                off_time: {
                  hrs: selectedEndTimeDate.getHours(),
                  mins: selectedEndTimeDate.getMinutes(),
                },
                version: currentVersion,
              }));

              const { user: lastModifiedBy, ch_dt: lastModifiedDate } =
                newDocumentObj || {};
              const { onTime, offTime } = timeConvertUtility(newDocumentObj);
              setScheduleHistoryData((prevState) => [
                {
                  onTime,
                  offTime,
                  lastModifiedBy,
                  lastModifiedDate: format(lastModifiedDate, "MM/dd/yyyy"),
                },
                ...prevState,
              ]);
            })
            .catch((err) => {
              console.log("Schedule history add document error : ", err);
            });
        })
        .catch((error) => {
          console.log("Schedule update document error : ", error);
        });
    } else {
      const newHistoryObj = {
        name: "default",
        on_time: {
          hrs: selectedStartTimeDate.getHours(),
          mins: selectedStartTimeDate.getMinutes(),
        },
        off_time: {
          hrs: selectedEndTimeDate.getHours(),
          mins: selectedEndTimeDate.getMinutes(),
        },
        user,
        ch_dt: new Date(),
        version: 1,
      };
      const newDocRef = doc(collection(db(), "schedules"), "default");
      const van = await setDoc(newDocRef, newHistoryObj)
        .then(() => {
          setScheduleDocId("default")
          console.log("schedule document created successfully");
          let newDocumentObj = {
            name: "default",
            on_time: {
              hrs: selectedStartTimeDate.getHours(),
              mins: selectedStartTimeDate.getMinutes(),
            },
            off_time: {
              hrs: selectedEndTimeDate.getHours(),
              mins: selectedEndTimeDate.getMinutes(),
            },
            user,
            ch_dt: new Date(),
            version: 1,
          };
          addDoc(collection(db(), "schedule_history"), {
            ...newDocumentObj,
          })
            .then((res) => {
              console.log("schedule history document added : ", res);
              setScheduledTime((prevState) => ({
                ...prevState,
                on_time: {
                  hrs: selectedStartTimeDate.getHours(),
                  mins: selectedStartTimeDate.getMinutes(),
                },
                off_time: {
                  hrs: selectedEndTimeDate.getHours(),
                  mins: selectedEndTimeDate.getMinutes(),
                },
                version: 1,
              }));

              const { user: lastModifiedBy, ch_dt: lastModifiedDate } =
                newDocumentObj || {};
              const { onTime, offTime } = timeConvertUtility(newDocumentObj);
              setScheduleHistoryData((prevState) => [
                {
                  onTime,
                  offTime,
                  lastModifiedBy,
                  lastModifiedDate: format(lastModifiedDate, "MM/dd/yyyy"),
                },
                ...prevState,
              ]);
            })
            .catch((err) => {
              console.log("Schedule history add document error : ", err);
            });
        })
        .catch((error) => {
          console.log("Schedule update document error : ", error);
        });
    }
    setIsOpenDialog(false)
  };

  const handleSelectedDate = (date, type) => {
    if (type === "dim-start") {
      setDimScheduleDialog((prevState) => ({
        ...prevState,
        start: date
      }));
    } else if (type === "dim-end") {
      setDimScheduleDialog((prevState) => ({
        ...prevState,
        end: date
      }));
    } else if (type === "start") {
      setSelectedStartTimeDate(date);
    } else {
      setSelectedEndTimeDate(date);
    }
  };

  const getSaveDisabledStatus = () => {
    if (scheduledTime) {
      const { off_time, on_time } = scheduledTime;
      const currentDate = new Date();
      const startTimeDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        on_time.hrs,
        on_time.mins
      );
      const endTimeDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        off_time.hrs,
        off_time.mins
      );
      return (
        isEqual(selectedStartTimeDate, startTimeDate) &&
        isEqual(selectedEndTimeDate, endTimeDate)
      );
    }
    return false;
  };

  const getScheduleHistoryColumnList = () => {
    return [
      {
        title: "Start Time",
        field: "onTime",
      },
      {
        title: "End Time",
        field: "offTime",
      },
      {
        title: "Modified By",
        field: "lastModifiedBy",
      },
      {
        title: "Date",
        field: "lastModifiedDate",
      },
    ];
  };

  const getScheduledTime = () => {
    const { onTime, offTime } = timeConvertUtility(scheduledTime);
    return (
      <>
        <div className="settings-schedule-time">
          <span>Start Time</span>
          <span>{onTime}</span>
        </div>
        <div className="settings-schedule-time">
          <span>End Time</span>
          <span>{offTime}</span>
        </div>
      </>
    );
    return `${onTime} - ${offTime}`;
  };

  const getScheduleInfoAPICall = async () => {
    let scheduleInfo = "";
    let docId = null;
    const q = query(
      collection(db(), "schedules"),
      where("name", "==", "default")
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      docId = doc.id;
      scheduleInfo = doc.data();
      console.log("schedule : ", doc.id);
    });
    setScheduleDocId(docId);
    setScheduledTime(scheduleInfo);
  };

  useEffect(() => {
    if (scheduledTime) {
      const { off_time, on_time } = scheduledTime;
      const currentDate = new Date();
      const startTimeDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        on_time.hrs,
        on_time.mins
      );
      const endTimeDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate(),
        off_time.hrs,
        off_time.mins
      );
      setSelectedStartTimeDate(startTimeDate);
      setSelectedEndTimeDate(endTimeDate);
    }
  }, [scheduledTime]);

  const getScheduleHistoryAPICall = async () => {
    let historyList = [];
    const q = query(
      collection(db(), "schedule_history"),
      where("name", "==", "default"),
      orderBy("ch_dt", "desc")
    );
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      const record = doc.data();
      historyList = [...historyList, record];
    });
    historyList = historyList.map((historyItem) => {
      const { user: lastModifiedBy, ch_dt: { seconds } = {} } =
        historyItem || {};
      const { onTime, offTime } = timeConvertUtility(historyItem);
      return {
        onTime,
        offTime,
        lastModifiedBy,
        lastModifiedDate: format(new Date(seconds * 1000), "MM/dd/yyyy"),
      };
    });
    setScheduleHistoryData(historyList);
  };

  /// Dim Schedule CRED Operations
  const OnClickAddDimSchedule = async () => {
    if (dimSchedule.sch_list === undefined | null) {
      dimSchedule["sch_list"] = [];
    }
    if (dimSchedule.sch_list?.length < 5) {
      setDimScheduleDialog({ view: 'add', start: new Date(), end: new Date(), dp: 0 });
    } else {
      NotificationManager.error("Maximum dim schedile added.", "", 3000);
    }
  }

  const OnClickEditDimSchedule = async (rowData) => {
    const { off_time, on_time, dp } = rowData;
    const currentDate = new Date();
    const startTimeDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      on_time.hrs,
      on_time.mins
    );
    const endTimeDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      off_time.hrs,
      off_time.mins
    );
    setDimScheduleDialog({ view: 'edit', data: rowData, start: startTimeDate, end: endTimeDate, dp: dp });
  }

  const OnClickDeleteDimSchedule = async (rowData) => {
    let index = rowData["tableData"]["id"];
    let { sch_list, ver = 0 } = dimSchedule;
    sch_list.splice(index, 1);
    // updateDimSchedule({
    //   sch_list:sch_list,
    //   ver:ver + 1,
    // }).then(() => {
    //   console.log("Deleted Successfully");
    // }).catch((e)=> {
    //   console.log("Delete Failed");
    // });

    // let configResponse = JSON.parse(
    //   localStorage.getItem("firebaseConfigApiResponse")
    // );
    // const user = configResponse?.user_email;
    // await createDimScheduleHistory({
    //   sch_list:sch_list,
    //   ver:ver + 1,
    //   user,
    //   ch_dt: new Date()
    // }).then(() => {
    //   console.log("History Created Successfully");
    // }).catch((e)=> {
    //   console.log("History Create Failed");
    // });

    setDimSchedule((prevState) => ({
      ...prevState,
      sch_list: sch_list,
      ver: ver + 1,
    }));

    setOnUpdateDimSchedule(true);
  }

  const OnClickSaveDimSchedule = async (enableStatusVal) => {
    if (enableStatusVal === true) {
      const _dimSchedule = JSON.parse(JSON.stringify(dimSchedule));
      let { sch_list, ver = 0 } = _dimSchedule;
      for (let i = 0; i < sch_list.length; i++) {
        delete sch_list[i]["tableData"];
      }
      await updateDimSchedule({
        sch_list: sch_list,
        ver: ver + 1,
      }).catch((e) => {
        console.log(`Added Failed ${e}`);
        NotificationManager.error("Failed to save Dim Schedule", "", 3000);
        return;
      });

      console.log("Added Successfully");
      NotificationManager.success("Dim Schedule saved successfully", "", 3000);

      // let configResponse = JSON.parse(
      //   localStorage.getItem("firebaseConfigApiResponse")
      // );
      // const user = configResponse?.user_email;
      let user = localStorage.getItem("userEmail");

      await createDimScheduleHistory({
        sch_list: sch_list,
        ver: ver + 1,
        user,
        ch_dt: new Date()
      }).then(() => {
        console.log("History Created Successfully");
      }).catch((e) => {
        console.log(`History Create Failed = ${e}`);
      });

      setDimSchedule((prevState) => ({
        ...prevState,
        sch_list: dimSchedule.sch_list,
        ver: ver + 1,
      }));
      setOnUpdateDimSchedule(false);
    } else {
      NotificationManager.error("No chnages to save Dim Schedule", "", 3000);
    }
  }

  const OnClickUpdateDimSchedule = async () => {
    let { sch_list, ver = 0 } = dimSchedule;
    let { dp } = dimScheduleDialog;
    if (parseInt(dp) === NaN) {
      NotificationManager.error("Please enter valid dim percentage", "", 3000);
      return;
    }
    //TODO: validation
    if (dimScheduleDialog.view === 'add') {  //Add dim schedule operation
      sch_list.push({
        on_time: {
          hrs: dimScheduleDialog.start.getHours(),
          mins: dimScheduleDialog.start.getMinutes()
        },
        off_time: {
          hrs: dimScheduleDialog.end.getHours(),
          mins: dimScheduleDialog.end.getMinutes()
        },
        "dp": parseInt(dp)
      });

    } else { //Edit dim schedule operation
      let index = dimScheduleDialog.data["tableData"]["id"];
      sch_list[index] = {
        on_time: {
          hrs: dimScheduleDialog.start.getHours(),
          mins: dimScheduleDialog.start.getMinutes()
        },
        off_time: {
          hrs: dimScheduleDialog.end.getHours(),
          mins: dimScheduleDialog.end.getMinutes()
        },
        "dp": parseInt(dp)
      }
    }
    setDimSchedule((prevState) => ({
      ...prevState,
      sch_list: sch_list,
    }));
    setOnUpdateDimSchedule(true);
    setDimScheduleDialog({ view: '', start: new Date(), end: new Date() });
  }

  const OnClickCancelDimSchedule = async () => {
    setDimScheduleDialog({ view: '' });
  }

  const OnChangeDimPercentage = (e) => {
    const { target: { value = "" } = {} } = e;
    setDimScheduleDialog((prevState) => ({
      ...prevState,
      dp: value
    }));
  }

  return (
    <div className="settings">
      <Grid container className="main-header">
        <Grid className="font-bold">Settings</Grid>
      </Grid>

      <Box sx={{ width: '100%', typography: 'body1' }}>
        <TabContext value={selectedTab} classes={{ root: classes.tab }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={onChangeTabView} aria-label="live meter feed" indicatorColor='primary'>
              <Tab label="SCHEDULE" value="1" />
              <Tab label="DIM SCHEDULE" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" style={{ padding: '0px' }}>
            <Grid container>
              <Grid xs={12} sm={4}>
                <div className="settings-schedule-wrapper">
                  <h5 className="header">Schedule</h5>
                  <div className="st-wrapper">{getScheduledTime()}</div>
                  <div className="edit-btn-wrapper">
                    <Button
                      variant="contained"
                      className="edit-btn"
                      onClick={handleEdit}
                    >
                      Edit
                    </Button>
                  </div>
                </div>
              </Grid>
              <Grid xs={12} sm={8}>
                <div className="dashboard-table settings-table">
                  <MaterialTable
                    style={{
                      // margin: "20px 0",
                      width: "100%",
                    }}
                    className={classes.table}
                    title={<div className="title">Schedule Change History</div>}
                    columns={getScheduleHistoryColumnList()}
                    data={scheduleHistoryData}
                    options={{
                      exportButton: false,
                      // grouping: true,
                      search: false,
                      selection: false,
                      sorting: true,
                      pageSize: 5,
                      headerStyle: {
                        backgroundColor: "#0071CE",
                        color: "#FFF",
                        fontSize: "0.9em",
                        textAlign: "center",
                      },
                      actionsColumnIndex: -1,
                      emptyRowsWhenPaging: false,
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value="2" style={{ padding: '0px' }}>
            <DimSchedule
              dimSchedule={dimSchedule}
              enableStatus={true}
              isUpdated={onUpdateDimSchedule}
              OnClickAddDimSchedule={OnClickAddDimSchedule}
              OnClickEditDimSchedule={OnClickEditDimSchedule}
              OnClickDeleteDimSchedule={OnClickDeleteDimSchedule}
              OnClickSaveDimSchedule={OnClickSaveDimSchedule}
            />
          </TabPanel>
        </TabContext>
      </Box>


      <Dialog
        className="change-schedule-dialog"
        onClose={handleClose}
        aria-labelledby="editTime-dialog-title"
        open={isOpenDialog}
        fullWidth
      >
        <DialogTitle id="editTime-dialog-title" onClose={handleClose}>
          Change Schedule
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="change-schedule-wrapper">
            <div style={{ marginRight: "10%" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  autoOk
                  label="Start Time"
                  value={selectedStartTimeDate}
                  onChange={(date) => handleSelectedDate(date, "start")}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  autoOk
                  label="End Time"
                  value={selectedEndTimeDate}
                  onChange={(date) => handleSelectedDate(date, "end")}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="save-btn"
            onClick={handleSave}
            disabled={getSaveDisabledStatus()}
          >
            Save
          </Button>
          <Button className="save-btn" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        className="change-schedule-dialog"
        onClose={OnClickCancelDimSchedule}
        aria-labelledby="editTime-dialog-title"
        open={dimScheduleDialog.view === '' ? false : true}
        fullWidth
      >
        <DialogTitle id="editTime-dialog-title" onClose={OnClickCancelDimSchedule}>
          {dimScheduleDialog.view === 'add' ? "Add" : "Edit"} Dim Schedule
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={OnClickCancelDimSchedule}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className="change-schedule-wrapper">
            <div style={{ marginRight: "10%" }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  autoOk
                  label="Start Time"
                  value={dimScheduleDialog.start}
                  onChange={(date) => handleSelectedDate(date, "dim-start")}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                  autoOk
                  label="End Time"
                  value={dimScheduleDialog.end}
                  onChange={(date) => handleSelectedDate(date, "dim-end")}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div style={{ marginLeft: "10%" }}>
              <TextField
                required
                id="standard-required"
                label="Dim Percentage"
                defaultValue={dimScheduleDialog.dp}
                variant="standard"
                onChange={OnChangeDimPercentage}
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="save-btn"
            onClick={OnClickUpdateDimSchedule}
            disabled={false}
          >
            Save
          </Button>
          <Button className="save-btn" onClick={OnClickCancelDimSchedule}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Settings;
